import React from 'react';

const Terms = () => {
  return (
    <div style={{ height: '100vh' }}>
      <iframe
        src="/docs/Terms of Service.pdf"
        title="Terms of Service"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
};

export default Terms;
